module.exports = __webpack_public_path__ + "images/124_1024.jpg";